import { render, staticRenderFns } from "./EducationalQualificationType.vue?vue&type=template&id=c24b5bd4&"
import script from "./EducationalQualificationType.vue?vue&type=script&lang=js&"
export * from "./EducationalQualificationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports